import flatten from './flatten'

/**
 * Recursively get child Vue components and optionally filter by type
 * @param   {Vue}  vm
 * @param   {String} type
 * @return  {Array}
 */
export default function (vm, type = false) {
  let children = getChildren(vm, type)
  // The first element in the array will be the parent element whose children
  // we're looking for so we'll remove that
  children.shift()
  children = flatten(children)
  return type ? children.filter(vm => vm.componentType === type) : children
}

function getChildren (vm) {
  return [vm, vm.$children.map(function (child) {
    return getChildren(child)
  })]
}



// WEBPACK FOOTER //
// ./src/frontend/util/getChildren.js